import React, { useEffect, useState } from 'react'
import { Container, Form, Table, Tabs, Tab } from 'react-bootstrap'
import { GAMES_COLLECTION } from '../../firebase'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'
import moment from 'moment'

const PreviewGame = () => {

    const history = useHistory()

    const [items, setItems] = useState([])

    const [search, setSearch] = useState('')

    const filteredItems = items.filter((item) => {

        let canReturnItem = false;

        const searchLowerCase = search.toLowerCase()

        if (item?.title_en && item.title_en.toLowerCase().includes(searchLowerCase)) {
            canReturnItem = true
        }
        if (item?.title_sr && item.title_sr.toLowerCase().includes(searchLowerCase)) {
            canReturnItem = true
        }

        return canReturnItem
    })

    useEffect(() => {

        const getItems = async () => {
            const snapshot = await GAMES_COLLECTION.get()
            const items = []
            snapshot.forEach(doc => {
                items.push(doc.data())
            })
            setItems(items)
        }

        getItems();

    }, [])

    return (
        <>
            <Container>
                <Tabs defaultActiveKey="preview-game" className="mb-3" transition={false}>
                    <Tab eventKey="preview-game" title="Pregled igara">
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Pretraga</Form.Label>
                                <Form.Control type="search" placeholder="Unesite pojam za pretragu..." onChange={(e) => setSearch(e.target.value)} />
                                <Form.Text className="text-muted">
                                    Pretražite prema polju Naslov (EN) i Naslov (SR).
                                </Form.Text>
                            </Form.Group>
                        </Form>
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>Uredi / obriši</th>
                                    <th>ID</th>
                                    <th>Prodaja (Offline profil)</th>
                                    <th>Prodaja (Primarni profil)</th>
                                    <th>Prodaja (Sekundarni profil)</th>
                                    <th>Kategorija</th>
                                    <th>Datum</th>
                                    <th>Popust</th>
                                    <th>Media</th>
                                    <th>Slika</th>
                                    <th>Poster (video)</th>
                                    <th>Ocjena</th>
                                    <th>Objavljeno</th>
                                    <th>Iznajmljivanje (8 dana)</th>
                                    <th>Iznajmljivanje (15 dana)</th>
                                    <th>Istaknuto (slider)</th>
                                    <th>URL</th>
                                    <th>Opis (EN)</th>
                                    <th>Opis (SR)</th>
                                    <th>Detalji (EN)</th>
                                    <th>Detalji (SR)</th>
                                    <th>Naslov (EN)</th>
                                    <th>Naslov (SR)</th>
                                    <th>Specifikacije i zahtjevi (EN)</th>
                                    <th>Specifikacije i zahtjevi (SR)</th>
                                    <th>Video</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredItems.map((item) => (
                                    <tr key={item._id}>
                                        <td>
                                            <div>
                                                <Link to={`/edit-game/${item._id}`}>
                                                    Uredi
                                                </Link>
                                                <br />
                                                <Link to={`/delete-game/${item._id}`}>
                                                    Obriši
                                                </Link>
                                                <br />
                                                <a href={`https://soniteka.com/game/${item.url}`} target="_blank" rel="noopener noreferrer">
                                                    Pregled
                                                </a>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item._id}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.buy_one}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.buy_two}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.buy_three}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.category ? item.category.map(item => <div key={item._id}>{item}</div>) : null}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.date ? moment(item.date.toDate()).format('DD/MM/YYYY') : '-'}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.discount}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <iframe
                                                    title="iframe"
                                                    width="100%"
                                                    height="100%"
                                                    src={item.iframe}
                                                    frameBorder="0"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                    allowFullScreen
                                                />
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <img src={item.image} alt="img" />
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <img src={item.poster} alt="poster" />
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.rating}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.release ? moment(item.release.toDate()).format('DD/MM/YYYY') : '-'}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.rent_one}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.rent_two}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.slider === true ? 'Da' : 'Ne'}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.url}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.description_en}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.description_sr}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.details_en}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.details_sr}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.title_en}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.title_sr}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.specifications_and_requirements_en}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.specifications_and_requirements_sr}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <video
                                                    poster={item.poster}
                                                    height="100%"
                                                    width="100%"
                                                    autoPlay={false}
                                                    loop={false}
                                                    muted
                                                    preload="none"
                                                    playsInline
                                                    controls
                                                >
                                                    <source src={item.video} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Tab>
                    <Tab eventKey="add-game" title={<div onClick={() => history.push('/add-game')}>Dodaj</div>} />
                    <Tab eventKey="edit-game" title='Uredi' disabled />
                    <Tab eventKey="delete-game" title='Obriši' disabled />
                </Tabs>
            </Container>
        </>
    )
}

export default PreviewGame
